const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as Record<string, any>;
    
    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }
    
    // Merge translation content (handle default export or named like common)
    const content = module.default || module.common || Object.values(module)[0];
    if (content) {
      messages[lang].translation = {
        ...messages[lang].translation,
        ...content
      };
    }
  }
});

export default messages; 
